import React, { useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
import { LanguageContext } from "../../contexts/LanguageContext";
import { StyledClients, ClientsGrid, ClientLogo } from "./styles";
import logoBermudes from "../../images/logo_bermudes.png";
import logoGameiro from "../../images/gameiro.png";
import logoCalfat from "../../images/calfat.png";
import logoPadilha from "../../images/padilha.png";
import logoJG from "../../images/jg2.png";
import logoMurayama from "../../images/murayama.png";
import logoTavad from "../../images/tavad_chacur.png";
import logoRaphaelMiranda from "../../images/logo-raphael-miranda.png";
import logoGCS from "../../images/GCD.png";
import logoAcrux from "../../images/acrux.png";
import logoHotta from "../../images/hotta.png";
import logoVianna from "../../images/vianna__1_-removebg-preview.png";
import logoSantesso from "../../images/santesso.png";
import logoAntonelli from "../../images/antonelli.png";
import logoRafe from "../../images/rafeadv.avif";

const Clients = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);

  // Normalmente esses dados viriam de uma API
  const clients = [
    { id: 1, name: "Sergio Bermudes", image: logoBermudes, bgColor: "#324C5B" },
    { id: 2, name: "Bruno Calfat", image: logoCalfat, bgColor: "#122134" },
    { id: 3, name: "Gameiro", image: logoGameiro, bgColor: "#fff" },
    { id: 4, name: "J.G", image: logoJG, bgColor: "#fff" },
    { id: 5, name: "Murayama", image: logoMurayama, bgColor: "#77a3bb" },
    { id: 6, name: "Tavares e Chacur", image: logoTavad, bgColor: "#fff" },
    {
      id: 7,
      name: "Raphael Miranda",
      image: logoRaphaelMiranda,
      bgColor: "#fff",
    },
    { id: 8, name: "Granadas, Carneiro", image: logoGCS, bgColor: "#052136" },
    { id: 9, name: "Acrux", image: logoAcrux, bgColor: "#001323" },
    { id: 10, name: "Hotta", image: logoHotta, bgColor: "#fff" },
    { id: 11, name: "Vianna", image: logoVianna, bgColor: "#fff" },
    {
      id: 12,
      name: "Santesso Campanario",
      image: logoSantesso,
      bgColor: "#e6e6e4",
    },
    { id: 13, name: "Antonelli", image: logoAntonelli, bgColor: "#f8f5f4" },
    { id: 14, name: "Gustavo Padilha", image: logoPadilha, bgColor: "#fff" },
    { id: 15, name: "Rafe", image: logoRafe, bgColor: "#111C48" },
  ];

  return (
    <StyledClients id="clientes">
      <div className="container">
        <h2 dangerouslySetInnerHTML={{ __html: translations[language].clientsTitle }} />
        <ClientsGrid>
          {clients.map((client, index) => (
            <ClientLogo
              key={client.id}
              bgColor={client.bgColor}
              data-aos="fade-up"
              data-aos-delay={index * 10}
            >
              <img src={client.image} alt={client.name} />
            </ClientLogo>
          ))}
        </ClientsGrid>
      </div>
    </StyledClients>
  );
};

export default Clients;
